export default {
  message: {
    customerNumbersAssistant: {
      date: {
        title: 'Punkte ab dem Datum X berechnen',
        warning:
          'Mit einem ausgewählten Datum können keine Hauptgeschäftsnummern verschoben werden!',
      },
      import: {
        openButton: 'Kundennummern importieren',
        loadingModal: 'Modal wird geladen...',
        title: 'Kundennummern aus Excel importieren',
        validateButton: 'Datei prüfen',
        submitButton: 'An API senden',
        submitButtonLoading: 'Wird gesendet...',
        selectWholesalerLabel: 'Großhändler',
        selectGroupLabel: 'Gruppe',
        selectWholesalerPlaceholder: 'Großhändler auswählen',
        selectGroupPlaceholder: 'Gruppe auswählen (optional)',
        requirementsTitle: 'Dateianforderungen',
        fileFormatRequirement: 'Nur Excel-Datei: .xlsx oder .xls',
        headerRequirement: 'Kopfzeile muss sein: Customer number, Email (Spalten A/B).',
        createdLabel: 'Erstellt',
        alreadyExistsLabel: 'Bereits vorhanden',
        success: 'Excel-Datei ist gültig.',
        submitSuccess: 'Kundennummern wurden erfolgreich importiert.',
        previewTitle: 'Vorschau',
        summaryTitle: 'Validierungszusammenfassung',
        previewCount: '{count} Zeilen, {pageSize} Zeilen pro Seite.',
        importableCountLabel: 'Kann importiert werden',
        skippedCountLabel: 'Wird übersprungen',
        searchPlaceholder: 'Suche nach Zeile, Kundennummer, E-Mail oder Status',
        confirmImportTitle: 'Import bestätigen',
        confirmImportQuestion: 'Möchten Sie die verfügbaren Datensätze jetzt importieren?',
        confirmImportButton: 'Jetzt importieren',
        filters: {
          all: 'Alle',
          importable: 'Importierbar',
          skipped: 'Übersprungen',
        },
        row: 'Zeile',
        customerNumber: 'Kundennummer',
        email: 'E-Mail',
        status: 'Status',
        userExists: 'Benutzer existiert',
        customerNumberExists: 'Kundennummer existiert',
        customerNumberExistsForEmail: 'Kundennummer existiert für E-Mail',
        customerNumberOwnerEmail: 'E-Mail des Kundennummer-Inhabers',
        conflictsFound: 'Es wurden Konflikte gefunden. Beheben Sie sie vor dem Import.',
        previousPage: 'Zurück',
        nextPage: 'Weiter',
        pageInfo: 'Seite {current} / {total}',
        progressLabel: 'Fortschritt',
        statusLabels: {
          available_for_import: 'Bereit für Import',
          already_linked: 'Bereits verknüpft',
          customer_number_linked_to_other_user: 'Kundennummer ist einem anderen Benutzer zugeordnet',
          user_not_found: 'Benutzer nicht gefunden',
          user_not_dealer: 'Benutzer ist kein Händler',
          user_in_other_group: 'Benutzer ist in einer anderen Gruppe',
        },
        summaryLabels: {
          total_rows: 'Alle Zeilen',
          available_for_import: 'Bereit für Import',
          already_linked: 'Bereits verknüpft',
          customer_number_linked_to_other_user: 'Einem anderen Benutzer zugeordnet',
          user_not_found: 'Benutzer nicht gefunden',
          user_not_dealer: 'Benutzer ist kein Händler',
          user_in_other_group: 'Benutzer in anderer Gruppe',
        },
        errors: {
          wholesalerRequired: 'Großhändler ist erforderlich.',
          groupRequired: 'Gruppe ist erforderlich.',
          fileRequired: 'Excel-Datei ist erforderlich.',
          emptyWorkbook: 'Excel-Arbeitsmappe ist leer.',
          invalidHeaders: 'Datei muss genau 2 Spalten enthalten: Kundennummer und E-Mail.',
          emptyRows: 'Datei enthält keine Datenzeilen.',
          firstTwoColumnsRequired: 'Zeile {row}: Die erste und zweite Spalte müssen ausgefüllt sein.',
          invalidCustomerNumber: 'Ungültige Kundennummer in Zeile {row}. Nur Buchstaben und Ziffern sind erlaubt.',
          invalidEmail: 'Ungültige E-Mail in Zeile {row}.',
          invalidFileType: 'Nur Excel-Dateien (.xlsx, .xls) sind erlaubt.',
          readError: 'Excel-Datei konnte nicht gelesen werden.',
          validateFirst: 'Bitte zuerst die Datei validieren.',
          conflictsBeforeImport: 'Import ist wegen Validierungskonflikten blockiert.',
          nothingToImport: 'Es gibt keine Datensätze, die importiert werden können.',
          submitFailed: 'Datensätze konnten nicht an die API gesendet werden.',
        },
      },
    },
  },
}
